<div class="row mb-5">
  <div class="col-lg-12">
        <div class="tickets-container h-auto">
          <div class="tickets-list bg-white card shadow-sm hover-shadow transition-fast rounded-lg mb-5 overflow-hidden">
                                <ng-container *ngIf="isLoading">
                        <div class="d-flex justify-content-center align-items-center my-5">
                            <div class="spinner-grow" style="width: 2rem; height: 2rem;" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </ng-container>                       
                    <ng-container *ngIf="!isLoading">

            <div class="container p-5 px-0 px-lg-4 py-lg-4">
              <div class="row">                
                <!-- Header & Add Ticket Button -->
                <div class="col-12 text-start">
                  <div class="container">
                    <div class="row">
                      <div class="col-12">
                        <h4 class="font-weight-bold text-center text-lg-start mb-4">الدعـم الفنـي</h4>
                        <!-- Open Ticket Modal -->
                        <button
                          title="إضافة تذكرة جديدة"
                          class="btn btn-sm btn-outline-dark rounded-lg px-5 mt-1"
                          data-bs-toggle="modal"
                          data-bs-target="#createTicketModal"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Ticket List -->
                <div class="col-12">
                  <div class="overflow-y-auto position-relative custom-scroll" style="height: 80vh;">
                    <div class="container-fluid">
                      <div class="row">
                        <div *ngFor="let ticket of tickets" class="col-12 py-3 tickets-list-item">
                          <a 
                            (click)="openTicket(ticket.id)" 
                            class="link-dark cursor-pointer p-3 d-block"
                            [ngClass]="{ 'bg-light border-start border-primary': selectedTicket?.id === ticket.id }"
                          >
                            <div class="row">
                              <div class="col-10">
                                <h6 class="mb-0">{{ ticket.subject }}</h6>
                                <small class="text-black-50">{{ ticket.created_at }}</small>
                              </div>
                              <div class="col-2 text-end">
                                <span
                                  title="{{ ticket.closed ? 'مغلقة' : 'مفتوحة' }}"
                                  [ngClass]="{ 'text-warning': !ticket.closed, 'text-success': ticket.closed }"
                                  class="material-icons"
                                >
                                  circle
                                </span>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Ticket List -->
              </div>
            </div>
          </ng-container>

          </div>
        </div>
      </div>
    </div>

<!-- Create Ticket Modal -->
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" [id]="modalName" tabindex="-1" aria-labelledby="createTicketModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content glassmorphism-card rounded-lg px-2 px-lg-5 py-3">
      
      <!-- Modal Header -->
      <div class="modal-header border-bottom">
        <h4 class="modal-title font-weight-bold" id="createTicketModalLabel">إنشاء تذكرة جديدة</h4>
        <button (click)="changeStatusToClosed(modalName)" #closeButton type="button" class="btn-close" data-bs-dismiss="modal" aria-label="إغلاق"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <app-loader-spinner [color]="'success'" *ngIf="isLoading"></app-loader-spinner>

        <ng-container *ngIf="!isLoading">
          <form #ticketForm="ngForm">
            
            <!-- Subject Input -->
            <div class="mb-3">
              <label class="form-label">عنوان الطلب</label>
              <input type="text" class="form-control" [(ngModel)]="newTicket.subject" name="subject" required 
                     (input)="validateSubject()" (blur)="subjectTouched = true; validateSubject()" />

              <!-- Error Message (Only shown after user leaves the field) -->
              <div *ngIf="subjectTouched && subjectError" class="text-danger mt-2">
                {{ subjectError }}
              </div>
            </div>

            <!-- Message Input -->
            <div class="mb-3">
              <label class="form-label">التفاصيل</label>
              <textarea class="form-control" rows="4" [(ngModel)]="newTicket.message" name="message" required
                        (input)="validateMessage()" (blur)="messageTouched = true; validateMessage()"></textarea>

              <!-- Error Message (Only shown after user leaves the field) -->
              <div *ngIf="messageTouched && messageError" class="text-danger mt-2">
                {{ messageError }}
              </div>
            </div>
          </form>
        </ng-container>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button (click)="changeStatusToClosed(modalName)" type="button" class="btn btn-outline-dark w-auto rounded-pill mx-auto pt-0 px-4 mt-2 me-2" data-bs-dismiss="modal">إلغاء</button>
        <button type="button" class="btn btn-success w-auto rounded-pill mx-auto pt-0 px-4 mt-2" [disabled]="subjectError || messageError" (click)="submitNewTicket(ticketForm)">
          إرسال التذكرة
        </button>
      </div>

    </div>
  </div>
</div>

  